<po-page-list
  p-title="Netrin - Consulta Cadastro (Cliente e Fornecedor)"
  [p-breadcrumb]="poPageBreadcrumb"
  [p-filter]="poPoPageFilter"
  [p-actions]="poPageActions"
>
  <po-table
    #poTabelaPrincipal
    class="po-md-12"
    [p-columns]="tabelaPrimariaColumns"
    [p-items]="tabelaPrimariaDados"
    [p-height]="500"
    p-spacing="small"
    [p-container]="true"
    [p-hide-table-search]="false"
    [p-selectable]="true"
    [p-sort]="true"
  ></po-table>
</po-page-list>


<po-modal #modalFiltroAvancadoTabelaPrincipal p-title="Filtro" [p-primary-action]="modalFiltroAvancadoTabelaPrincipalActions">
  <po-datepicker
    class="po-md-12 po-xl-6"
    p-label="Data da Última Compra/Venda de:"
    p-placeholder="Selecione uma data"
    name="DULTCOM"
    [(ngModel)]="tabelaPrimariaFiltro.dados.DULTCOM"
    [p-required]="false"
    [p-format]="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
    [p-clean]="true"
  ></po-datepicker>
  <po-datepicker
    class="po-md-12 po-xl-6"
    p-label="Data da Última Consulta:"
    p-placeholder="Selecione uma data"
    name="DATU"
    [(ngModel)]="tabelaPrimariaFiltro.dados.DATU"
    [p-required]="false"
    [p-format]="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
    [p-clean]="true"
  ></po-datepicker>
  <po-combo
    class="po-md-12"
    p-label="Tipo"
    p-placeholder="Selecione um tipo"
    name="CTIPO"
    [(ngModel)]="tabelaPrimariaFiltro.dados.CTIPO"
    [p-options]="tabelaPrimariaFiltro.tipoOrigemPoComboOptions"
    [p-required]="false"
    [p-clean]="true"
  ></po-combo>
  <po-lookup class="po-md-12 po-xl-6"
    p-label="Fornecedor"
    p-placeholder="Pesquisar"
    name="CFORNECEDORLOJA"
    [(ngModel)]="tabelaPrimariaFiltro.dados.CFORNECEDORLOJA"
    p-field-label="CA2NREDUZ"
    p-field-value="CA2CODLOJA"
    [p-columns]="fornecedorColumnsFilters"
    [p-field-format]="fornecedorLookupService.getFieldFormater"
    [p-filter-service]="fornecedorLookupService"
    [p-advanced-filters]="fornecedorLookupService.getAdvancedFilter()"
    [p-literals]="{ modalTitle: 'Fornecedor' }"
    [p-clean]="true"
  ></po-lookup>
  <po-lookup
    class="po-md-12 po-xl-6"
    p-placeholder="Pesquisar"
    name="CCLIENTELOJA"
    [(ngModel)]="tabelaPrimariaFiltro.dados.CCLIENTELOJA"
    p-field-label="CA1NREDUZ"
    p-field-value="CA1CODLOJA"
    p-label="Cliente"
    [p-columns]="clientecolumnsFilters"
    [p-field-format]="clienteLookupService.getFieldFormater"
    [p-filter-service]="clienteLookupService"
    [p-advanced-filters]="clienteLookupService.getAdvancedFilter()"
    [p-literals]="{ modalTitle: 'Cliente' }"
    [p-clean]="true"
  ></po-lookup>
</po-modal>


<po-modal #modalDadosBusca p-title="Netrin - Iniciar Consulta(s)">
  <po-widget class="po-md-12">
    <div class="po-font-subtitle">Prezado(a),</div>
    <div>
      O processo que você iniciou vai rodar em segundo plano. Assim que ele for finalizado, você receberá uma notificação (workflow) para que possa analisar os resultados e salvar o processo.
    </div>
  </po-widget>
  <po-widget p-title="Selecione as Fontes de Consulta" class="po-md-12">
    <po-switch class="po-md-12 po-xl-4"
      p-label="Receita Federal"
      name="LCONSULTARECEITA"
      [(ngModel)]="dadosParceiroDeNegocioAtualizar.LCONSULTARECEITA"
      p-label-off="Não"
      p-label-on="Sim"
    ></po-switch>
    <po-switch class="po-md-12 po-xl-4"
      p-label="Sintegra"
      name="LCONSULTASINTEGRA"
      [(ngModel)]="dadosParceiroDeNegocioAtualizar.LCONSULTASINTEGRA"
      p-label-off="Não"
      p-label-on="Sim"
    ></po-switch>
    <po-switch class="po-md-12 po-xl-4"
      p-label="Simples Nacional"
      name="LCONSULTASIMPLES"
      [(ngModel)]="dadosParceiroDeNegocioAtualizar.LCONSULTASIMPLES"
      p-label-off="Não"
      p-label-on="Sim"
    ></po-switch>
  </po-widget>
  <po-modal-footer>
    <po-button
      p-label="Iniciar Busca"
      p-icon="po-icon-refresh"
      (p-click)="buscarDadosNetrin()"
      p-kind="primary"
    ></po-button>
  </po-modal-footer>
</po-modal>
